module.exports = "<p>\n  redirect works!\n</p>\n"